<template>
  <div>
    <small>
      {{ 'Already have an account?' | translate }}
      <a href="#" @click.prevent="openModal">
        {{ 'Sign in' | translate }}
      </a>
    </small>
    <div
      ref="modal"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="loginModal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ 'Sign in' | translate }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="inputEmail" class="">
                <small>{{ 'Email' | translate }}</small>
              </label>
              <input
                type="email"
                id="inputEmail"
                class="form-control"
                :class="{ 'is-invalid': 'email' in errors }"
                required=""
                autofocus=""
                v-model="email"
              />
              <InputErrors name="email" :errors="errors"></InputErrors>
            </div>
            <div class="mb-3">
              <label for="inputPassword" class="">
                <small>{{ 'Password' | translate }}</small>
              </label>
              <input
                type="password"
                id="inputPassword"
                class="form-control"
                :class="{ 'is-invalid': 'password' in errors }"
                required=""
                v-model="password"
              />
              <InputErrors name="password" :errors="errors"></InputErrors>
            </div>

            <a href="/password/reset">
              <small>{{ 'Forgot Your Password?' | translate }}</small>
            </a>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="hideModal"
            >
              {{ 'Cancel' | translate }}
            </button>
            <button
              @click.prevent="login"
              type="button"
              class="btn btn-primary"
            >
              {{ 'Sign in' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../helpers/api'
import InputErrors from './InputErrors'
import _ from 'lodash'

export default {
  components: {
    InputErrors,
  },
  data() {
    return {
      email: null,
      password: null,
      errors: [],
    }
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal, {})
  },
  computed: {
    course_id() {
      return _.get(this.$store.state, 'course.id', null)
    },
  },
  methods: {
    openModal() {
      this.modal.show()
    },
    hideModal() {
      this.errors = []
      this.email = null
      this.password = null
      this.modal.hide()
    },
    setView() {
      this.$store.commit('setView', 'register')
    },
    async login() {
      try {
        let loginData = {
          email: this.email,
          password: this.password,
        }

        if (this.course_id) {
          loginData.course_id = this.course_id
        }

        const response = await api.login(loginData)
        this.$store.commit('updateUser', response.data.student)
        this.$store.commit('updateHasAccess', response.data.has_access)
        this.hideModal()
      } catch (error) {
        let status = _.get(error, 'response.status')

        if (status === 422) {
          this.errors = _.get(error, 'response.data.errors', [])
        } else {
          console.error(error)
        }
      }
    },
  },
}
</script>
